import { useQuery } from '@apollo/client';

export const useImperativeQuery = (query, options = {}) => {
  const { refetch } = useQuery(query, { skip: true, ...options });
  return ({ variables } = {}) => refetch(variables);
};
